import { Box, Stack, StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Swiper } from "swiper/react";

export const CarouselStyle = styled(Stack)(() => ({
  display: "flex",
  flexGrow: 1,
  gap: "1rem"
}));

export const Navigation = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "isCarouselView"
})<StackProps & { isCarouselView: boolean }>(({ isCarouselView }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: isCarouselView ? "space-between" : "flex-end",
  ".left-navigation-container": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "0.6875rem"
  },
  ".right-navigation-container": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem"
  }
}));

export const StyledCarousel = styled(Swiper)(() => ({
  ".swiper-slide": {
    width: "23.5rem"
  },
  ".swiper-wrapper":{
  },
  width: "auto"
}));


export const StyledBoxShadowLeft = styled(Box)(() => ({
  position: "absolute",
  top: "-3px",
  bottom: "-3px",
  width: "40px",
  background: "linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0))",
  pointerEvents: "none",
  zIndex: 2,
  borderTopLeftRadius: "10px",
  borderBottomLeftRadius: "10px"
}));
export const StyledBoxShadowRight = styled(Box)(() => ({
  position: "absolute",
  right: 0,
  top: "-3px",
  bottom: "-3px",
  width: "40px",
  background: "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
  pointerEvents: "none",
  zIndex: 2,
  borderTopRightRadius: "10px",
  borderBottomRightRadius: "10px"
}));
